import {Injectable} from '@angular/core'
import {Title} from "@angular/platform-browser";
import {environment} from "../../environments/environment";
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";
import {LocaleService} from "./locale.service";

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  public title$: BehaviorSubject<string> = new BehaviorSubject<string>('')
  private currentTitleTranslationString?: string

  public setTranslatedTitle(translationString: string): void {
    this.currentTitleTranslationString = translationString;
    const translated = this.translate.instant(translationString);
    this.set(translated);
  }

  public setTitle(title: string): void {
    this.set(title);
  }

  private set(title: string): void {
    if (!environment.production) {

      if (environment.env_name === 'local') {
        title += '🔴'
      }
      if (environment.env_name === 'local-stage') {
        title += '🟠'
      }
      if (environment.env_name === 'stage') {
        title += '🟢'
      }
      title += '[' + environment.env_name + '] ';
    }

    const fullTitle = title + ' - BMW Ticketshop ';
    this.title.setTitle(fullTitle)

    this.title$.next(fullTitle);
  }

  public constructor(
    private readonly title: Title,
    private readonly translate: TranslateService,
    private localeService: LocaleService
  ) {
    this.localeService.localeChanged.subscribe(
      () => {
        if(this.currentTitleTranslationString) {
          this.setTranslatedTitle(this.currentTitleTranslationString)
        }

      }
    )
  }
}
